import Auth from '@/bootstrap/auth/jwt-auth'

const auth = new Auth()

export {
  auth,
}
